/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  AmenitiesLine component
 */
/** @jsx jsx */
import { jsx } from '@emotion/react'
import type { Listable } from '@zcode/state-type'
import * as styles from './styles'

export interface Props {
  listable: Listable
}

export const AmenitiesLine = ({ listable }: Props) => {
  const amenitiesItems = listable.combinedAmenities
  if (amenitiesItems.length === 0) {
    return null
  }
  const amenitiesText = amenitiesItems.slice(0, 3).join(' • ')
  return <div css={styles.amenitiesLine}>{amenitiesText}</div>
}
